import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M278.385-152.31q-26.176 0-46.485-17.146-20.309-17.145-24.822-43.315l-56.234-337.038q-2.765-16.575 7.681-29.537 10.447-12.961 27.707-12.961h587.536q17.26 0 27.707 12.961 10.446 12.962 7.681 29.537l-56.234 337.038q-4.513 26.17-24.822 43.315-20.309 17.146-46.485 17.146h-403.23zM400-382.309h160q12.75 0 21.375-8.629 8.624-8.629 8.624-21.384 0-12.756-8.624-21.371-8.625-8.615-21.375-8.615H400q-12.75 0-21.374 8.629-8.625 8.628-8.625 21.384 0 12.755 8.625 21.371 8.624 8.615 21.374 8.615zM240-640q-12.75 0-21.374-8.629-8.625-8.628-8.625-21.384 0-12.755 8.625-21.37 8.624-8.616 21.374-8.616h480q12.75 0 21.375 8.629 8.624 8.629 8.624 21.384 0 12.756-8.624 21.371Q732.75-640 720-640H240zm80-107.691q-12.75 0-21.374-8.629-8.625-8.629-8.625-21.384 0-12.756 8.625-21.371 8.624-8.615 21.374-8.615h320q12.75 0 21.375 8.629 8.624 8.628 8.624 21.384 0 12.755-8.624 21.37-8.625 8.616-21.375 8.616H320z"
      ></path>
    </svg>
  );
}

export default Icon;
